import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/LoginView.vue'
import Notice from '../views/notice/NoticeView.vue'
import Dashboard from '../views/DashBoard.vue'
import Policy from '../views/policy/PolicyView.vue'
import Terms from '../views/terms/TermsView.vue'
import Guide from '../views/guide/GuideView.vue'
import store from '../store/index'

const routes = [
    { path: '/', component: Login, meta: { requiresUnAuth: true } },
    { path: '/login', component: Login, meta: { requiresUnAuth: true } },

    { path: '/dashboard', component: Dashboard, meta: { requiresAuth: true } },

    { path: '/notice', component: Notice, meta: { requiresAuth: true } },
    { path: '/notice/post', component: () => import('../views/notice/PostNotice.vue'), meta: { requiresAuth: true } },
    { path: '/notice/edit', component: () => import('../views/notice/EditNotice.vue'), meta: { requiresAuth: true } },

    { path: '/guide', component: Guide, meta: { requiresAuth: true } },
    { path: '/guide/edit', component: () => import('../views/guide/EditGuide.vue'), meta: { requiresAuth: true } },
    { path: '/policy', component: Policy, meta: { requiresAuth: true } },
    { path: '/terms', component: Terms, meta: { requiresAuth: true } },

    { path: '/users', component: () => import('../views/users/UsersView.vue'), meta: { requiresAuth: true } },
]

const router = createRouter({
    history: createWebHistory(),
    routes
});

router.beforeEach(function (to, from, next) {
    if (to.meta.requiresAuth && !store.getters['login/isAuthenticated']) {
        next('/login');
    }
    else if (to.meta.requiresUnAuth && store.getters['login/isAuthenticated']) {
        next('/dashboard');
    } else {
        next();
    }
})
export default router